import React from "react";
import { useNavigate } from "react-router-dom";
import { RUPEE } from "../../../constants/globalConstants";
import "./RecommendedProductCard.css";
import { getOptimizedUrl, getPrice } from "../../../constants/globalFunction";

const RecommendedProductCard = ({ product }) => {
  const navigate = useNavigate();

  const onPress = () => {
    const productUrl = `/product?product_id=${product?._id}`;
    window.open(productUrl, "_blank");
  };

  const displayImages = product?.image || [];
  const firstImage = displayImages?.[0]?.image;

  return (
    <div className="recommendedProductCard" onClick={onPress}>
      <div className="recommendedProductCard__image-container">
        {firstImage ? (
          <img
            className="recommendedProductCard__img"
            src={getOptimizedUrl(firstImage)}
            alt={product?.name || "product"}
            loading="lazy"
          />
        ) : (
          <div className="recommendedProductCard__img recommendedProductCard__img--placeholder" />
        )}
      </div>
      <div className="recommendedProductCard__content">
        <div className="recommendedProductCard__name" title={product?.name}>
          {product?.name}
        </div>
        <div className="recommendedProductCard__price">
          {product?.size?.mrp && parseInt(product?.size?.mrp) > 0 && (
            <span className="recommendedProductCard__price-mrp">
              {RUPEE}
              {product?.size?.mrp}
            </span>
          )}
          <span className="recommendedProductCard__price-current">
            {RUPEE}
            {getPrice(product?.size)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RecommendedProductCard;
